import {
  AdvancedFilterDataSchema,
  FilterGroupSchema,
} from "@redotech/redo-views-common/advanced-filters/advanced-filter-data";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const updatePickSessionPriorityFilter = {
  name: "updatePickSessionPriorityFilter" as const,
  input: z.object({
    id: zExt.objectId(),
    name: z.string().optional(),
    filters: z.array(AdvancedFilterDataSchema).optional(),
    filterGroup: FilterGroupSchema.optional(),
    percentage: z.number().min(0).max(100).optional(),
    clusterSelection: z.boolean().optional(),
    position: z.number().optional(),
  }),
  output: z.object({ success: z.boolean() }),
};
